import { render, staticRenderFns } from "./TitleControl.vue?vue&type=template&id=3deeaaa4"
import script from "./TitleControl.vue?vue&type=script&lang=ts"
export * from "./TitleControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports